import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { IPricingCard } from 'src/hooks/usePricingCards';
import { PriceBlockContainer } from './PriceBlock.styles';

interface PriceBlockProps extends Pick<IPricingCard, 'planTitle' | 'price' | 'supportingText'> {
  align?: 'left' | 'center';
}

const PriceBlock = ({ price, planTitle, align, supportingText }: PriceBlockProps): JSX.Element => (
  <PriceBlockContainer
    direction='column'
    justify={align === 'left' ? 'flex-start' : 'center'}
    align={align === 'left' ? 'flex-start' : 'center'}
    padding='spacing-4xl'
    gap='spacing-xl'
  >
    <Typography
      text={planTitle}
      type='paragraph'
      size='xl'
      fontWeight='font-weight-semibold'
      textAlign={align}
    />
    <Stack
      justify={align === 'left' ? 'flex-start' : 'center'}
      align={align === 'left' ? 'flex-end' : 'center'}
      direction={align === 'left' ? 'row' : 'column'}
      gap='spacing-xs'
    >
      <Typography
        text={`$${price}`}
        type='heading'
        size='xl'
        fontWeight='font-weight-semibold'
      />
      <Typography
        text='per month'
        type='paragraph'
        size='md'
        fontWeight='font-weight-medium'
        color='text-tertiary'
        className='period'
        whiteSpace='nowrap'
      />
    </Stack>
    <Typography
      text={supportingText}
      type='paragraph'
      size='md'
      color='text-tertiary'
    />
  </PriceBlockContainer>
);

export default PriceBlock;
